import styles from './index.module.scss'
import { Dropdown, Input, Space, Select, message, DatePicker } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useState, useContext, useEffect } from 'react'
import SelectBtnGroups from '@view/page_v3/components/SelectBtnGroups';
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import API from '@api/api.js';
const { RangePicker } = DatePicker;

const TASKTYPE = {
    'all': "全部展示",
    'tryonBatch': "AI试衣",
    'changeModelBatch': "换模特",
    'changeBkgBatch': "换背景",
}

const TASKSTATUS = {
    'all': "全部展示",
    0: "草稿",
    1: "排队中",
    2: "生成中",
    3: "已完成",
    4: "生成失败",
}

const ProListpageTop = (props) => {
    const { isProCenter, showMemberSelect } = props
    const { globalOrgInfo } = useContext(AppContext)

    const taskType = [{
        key: 'all',
        label: <p>全部类型</p>,
        onClick: () => props.getProjectType('all')
    }, {
        key: 'tryonBatch',
        label: <p>AI试衣</p>,
        onClick: () => props.getProjectType('tryonBatch')
    }, {
        key: 'changeModelBatch',
        label: <p>换模特</p>,
        onClick: () => props.getProjectType('changeModelBatch')
    }, {
        key: 'changeBkgBatch',
        label: <p>换背景</p>,
        onClick: () => props.getProjectType('changeBkgBatch')
    }]

    const taskStatus = [{
        key: 'all',
        label: <p>全部状态</p>,
        onClick: () => props.getProStatus('all')
    }, {
        key: 'draft',
        label: <p>草稿</p>,
        onClick: () => props.getProStatus(0)
    }, {
        key: 'pending',
        label: <p>排队中</p>,
        onClick: () => props.getProStatus(1)
    }, {
        key: 'processing',
        label: <p>生成中</p>,
        onClick: () => props.getProStatus(2)
    }, {
        key: 'completed',
        label: <p>已完成</p>,
        onClick: () => props.getProStatus(3)
    }, {
        key: 'failed',
        label: <p>生成失败</p>,
        onClick: () => props.getProStatus(4)
    }]

    // 成员列表
    const [memberList, setMemberList] = useState([]);
    const getListOrgMember = () => {
        API.getListOrgMember({}).then((res) => {
            if (res.code !== 0) return message.error(res.msg);
            const list = res.data.filter(item => item.role != 'admin').map(item => ({
                value: item.userId,
                label: item.deleted ? item.orgNickname + '（已移除）' : item.orgNickname,
            }));
            setMemberList(list);
        });
    }
    const memberChange = value => {
        props.getMember(value)
    };

    useEffect(() => {
        getListOrgMember()
    }, [])

    return (
        <div className={styles.ProListpageTop}>
            <div>
                <Dropdown menu={{ items: taskType }} trigger={['click']}>
                    <Space style={{ marginRight: '24px' }}>
                        {TASKTYPE[props.projectType]}
                        <DownOutlined className={styles.dropdown_action} />
                    </Space>
                </Dropdown>
                <Dropdown menu={{ items: isProCenter ? taskStatus.filter(item => item.key != 'draft') : taskStatus }} trigger={['click']}>
                    <Space style={{ marginRight: '24px' }}>
                        {TASKSTATUS[props.proStatus]}
                        <DownOutlined className={styles.dropdown_action} />
                    </Space>
                </Dropdown>
                {
                    ((globalOrgInfo?.current?.role == 'admin' && !isProCenter) || showMemberSelect) && <Select
                        style={{ width: 200, marginRight: '8px' }}
                        allowClear
                        value={props.member}
                        onChange={memberChange}
                        placeholder="请选择成员"
                        options={memberList}
                    />
                }

                <RangePicker
                    style={{ width: 250 }}
                    format="YYYY-MM-DD"
                    onChange={(value) => {
                        if (value) {
                            props.getStartTime(value[0].format('YYYY-MM-DD'));
                            props.getEndTime(value[1].format('YYYY-MM-DD'));
                        } else {
                            props.getStartTime(null);
                            props.getEndTime(null);
                        }
                    }}
                />

                <Input
                    allowClear
                    // value={projectName}
                    className={styles.focused}
                    placeholder="搜索项目名"
                    suffix={<Iconfont type="icon-SearchOutlined" style={{ fontSize: 16, color: '#5b6673' }} />}
                    onChange={(e) => props.getProjectSerial(e.target.value)}
                />
            </div>
            {/* <SelectBtnGroups
                getIsSelected={props.getIsSelected}
                setSelectedList={props.setSelectedList}
                selectedList={props.selectedList}
                isSelectedAll={props.isSelectedAll}
                downLoading={props.downLoading}
                selectAll={props.selectAll}
                deleteClick={props.deleteClick}
                downClick={props.downClick}
            /> */}
        </div>
    )
}

export default ProListpageTop
